<template>
    <div class="order">
        <div class="order-inner">
            <Header :title="$t('edit_photo')" :info="drawing ? `#${drawing.photo.id}` : ''"
                    @close-photo-editor="closePhotoEditor"/>
            <main class="flex-column align-items-center order-cropper" style="overflow: hidden;">
                <div class="cropper-wrap">
                    <vue-loading :active="!cropperReady" :is-full-page="false"/>
                    <img ref="preview" id="preview" :class="['cropper-preview', {'-show': !showCropper}]">
                    <img ref="originalPhoto" :src="drawing.photo.large_photo" class="d-none">
                    <vue-cropper ref="cropper" :class="['cropper', 'cropper-custom', {'-show': showCropper && cropperReady}]"
                                 :src="drawing.photo.large_photo" :ready="init" :zoom="zoom"
                                 :min-crop-box-width="drawing.photo.minWidth"
                                 :min-crop-box-height="drawing.photo.minHeight"
                                 :aspect-ratio="getAspectRatio(drawing.photo, drawing.sizes)"
                                 :zoom-on-wheel="false"
                                 :check-orientation="false"
                                 :view-mode="2" :auto-crop-area="1" :background="false"/>
                </div>
            </main>
            <Footer :show-cropper="showCropper" :show-filters="showFilters" :cropper-ready="cropperReady"
                    @crop="crop" @reset-crop="resetCrop"
                    @set-filter="setFilter"
                    @control="control" @modify="modify"
                    @hide-cropper="showCropper = false" @hide-filters="showFilters = false"
                    @show-cropper="showFilters = !(showCropper = true)" @show-filters="showCropper = !(showFilters = true)"/>
        </div>
    </div>
</template>

<style lang="scss">
    .cropper {
        opacity: 0;
        pointer-events: none;

        &-wrap {
            position: relative;
            flex-grow: 1;
            min-width: 100%;
            min-height: 100%;
            /*overflow: hidden;*/
        }

        &-custom {
            position: absolute;
            width: calc(100% - 12px);
            height: calc(100% - 12px);
            top: 6px;
            left: 6px;
        }

        &-preview {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            pointer-events: none;
            object-fit: contain;

            &.-show {

            }
        }

        &,
        &-preview {

            &.-show {
                opacity: 1;
                pointer-events: auto;
            }
        }

        &-view-box {
            outline: 3px dashed #000;
        }

        &-point {
            background-color: #000;
            opacity: 1;
            transform: scale(2);
        }

        &-dashed {
            border-color: #000;
        }

        &-line {
            background-color: transparent;
        }

        &-modal {
            opacity: 1;
            background-color: transparent;
        }

        &-canvas {

            &::after {
                position: absolute;
                content: '';
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background-color: rgba(#000, .3);
            }
        }

        &-preview {

        }
    }

    body.-is-mobile {
        .cropper {

            &-point {


                &.point {

                    &-sw {
                        width: 20px;
                        height: 20px;
                    }

                    &-se {
                        width: 5px;
                        height: 5px;
                    }
                }
            }
        }
    }
</style>

<script>
  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';

  import Header from './photo-editor/partials/Header.vue';
  import Footer from './photo-editor/partials/Footer.vue';

  import photoEditor from 'src/mixins/photoEditorComponent';

  export default {
    mixins: [photoEditor],
    components: {
      Header,
      Footer,
      VueCropper
    },
  };
</script>
